import { Button, Col, Form, Row } from "react-bootstrap";
import { Arbeit } from "../AddArbeitComponent/AddArbeitComponent";
import moment from "moment";
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';
import { FaPen } from '@react-icons/all-files/fa/FaPen';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FaTimes } from '@react-icons/all-files/fa/FaTimes';
import { Constants } from "../constants";
import { useState } from "react";

type ArbeitsZeileProps = {
    readonly arbeit: Arbeit;
    readonly index: number;
    deleteCallback: (index: number) => void;
    editCallback: (index: number, updated: Arbeit) => void;
};

export default function ArbeitsZeile(props: Readonly<ArbeitsZeileProps>) {
    const [editing, setEditing] = useState(false);
    const [von, setVon] = useState(moment(props.arbeit.von).format('YYYY-MM-DD'));
    const [bis, setBis] = useState(props.arbeit.bis ? moment(props.arbeit.bis).format('YYYY-MM-DD') : '');

    const translateArt = (artNummer: string): string => {
        if (artNummer === "0") return "Beschäftigungsverhältnis";
        else if (artNummer === "1") return "Aus- und Weiterbildung";
        else if (artNummer === "2") return "Arbeitslos";
        else if (artNummer === "3") return "Selbständig";
        else if (artNummer === "4") return "nicht zutreffend (Lücke)";
        else if (artNummer === "5") return "Vereinsmitgliedschaft";
        else if (artNummer === "6") return "Pension";
        return "FEHLER";
    };

    const save = () => {
        if (!von) return;
        props.editCallback(props.index, {
            ...props.arbeit,
            von: new Date(von),
            bis: bis ? new Date(bis) : undefined,
        });
        setEditing(false);
    };

    const cancel = () => {
        setVon(moment(props.arbeit.von).format('YYYY-MM-DD'));
        setBis(props.arbeit.bis ? moment(props.arbeit.bis).format('YYYY-MM-DD') : '');
        setEditing(false);
    };

    if (editing) {
        // Edit wie im Behörden-Portal: Von UND Bis editierbar — und auf
        // ALLEN Geräten sichtbar (die Spalten-Ausblendung fürs Handy gilt
        // hier bewusst nicht, sonst ist Bearbeiten am Telefon nutzlos).
        return <Row className="data-row border-bottom text-start align-items-center py-2">
            <Col xs={12} className='fw-bold text-truncate mb-1' title={props.arbeit.organisation}>
                {translateArt(props.arbeit.art)} · {props.arbeit.organisation}
            </Col>
            <Col xs={6} md={3}>
                <Form.Label className='mb-0 small text-muted'>Von</Form.Label>
                <Form.Control type='date' size='sm' value={von} max={moment().format('YYYY-MM-DD')} onChange={(e) => setVon(e.target.value)} />
            </Col>
            <Col xs={6} md={3}>
                <Form.Label className='mb-0 small text-muted'>Bis (leer = aktuell)</Form.Label>
                <div className='d-flex gap-1'>
                    <Form.Control type='date' size='sm' value={bis} max={moment().format('YYYY-MM-DD')} onChange={(e) => setBis(e.target.value)} />
                    {bis && <Button variant='outline-secondary' size='sm' onClick={() => setBis('')} title='Datum löschen (= aktuell)' className='d-inline-flex align-items-center justify-content-center flex-shrink-0' style={{width: '31px', padding: 0}}><FaTimes /></Button>}
                </div>
            </Col>
            <Col xs={12} md={6} className='d-flex justify-content-end gap-1 align-items-end mt-2 mt-md-0'>
                <Button variant='success' size='sm' onClick={save} title='Speichern' className='d-inline-flex align-items-center justify-content-center' style={{width: '32px', height: '32px', padding: 0}}><FaCheck /></Button>
                <Button variant='outline-secondary' size='sm' onClick={cancel} title='Abbrechen' className='d-inline-flex align-items-center justify-content-center' style={{width: '32px', height: '32px', padding: 0}}><FaTimes /></Button>
            </Col>
        </Row>;
    }

    // Handy: gestapelte Karte mit ALLEN Infos; Desktop: Tabellen-Zeile.
    return <Row className="data-row border-bottom text-start align-items-center py-2 py-md-1">
        <Col xs={12} className='d-md-none'>
            <div className='fw-semibold'>{props.arbeit.organisation}{props.arbeit.taetigkeit ? ` · ${props.arbeit.taetigkeit}` : ''}</div>
            <div className='text-muted small'>{translateArt(props.arbeit.art)}{props.arbeit.land ? ` (${props.arbeit.land})` : ''} · {moment(props.arbeit.von).format('DD.MM.YYYY')} – {props.arbeit.bis ? moment(props.arbeit.bis).format('DD.MM.YYYY') : 'aktuell'}</div>
        </Col>
        <Col md={2} className={Constants.HIDDEN_COLUMN_CLASSES + ' text-truncate'} title={translateArt(props.arbeit.art)}>{translateArt(props.arbeit.art)}</Col>
        <Col md={2} className='d-none d-md-block text-truncate' title={props.arbeit.organisation}>{props.arbeit.organisation}</Col>
        <Col md={2} className={Constants.HIDDEN_COLUMN_CLASSES + ' text-truncate'} title={props.arbeit.taetigkeit}>{props.arbeit.taetigkeit}</Col>
        <Col md={1} className={Constants.HIDDEN_COLUMN_CLASSES}>{props.arbeit.land}</Col>
        <Col md={2} className='d-none d-md-block'>{moment(props.arbeit.von).format('DD.MM.YYYY')}</Col>
        <Col md={2} className={Constants.HIDDEN_COLUMN_CLASSES}>{props.arbeit.bis ? moment(props.arbeit.bis).format('DD.MM.YYYY') : 'aktuell'}</Col>
        <Col xs={12} md={1} className='d-flex justify-content-end gap-1 mt-1 mt-md-0'>
            <Button variant='outline-secondary' size='sm' onClick={() => setEditing(true)} title='Bearbeiten' className='d-inline-flex align-items-center justify-content-center' style={{width: '28px', height: '28px', padding: 0}}><FaPen /></Button>
            <Button variant='outline-danger' size='sm' onClick={() => props.deleteCallback(props.index)} title='Löschen' className='d-inline-flex align-items-center justify-content-center' style={{width: '28px', height: '28px', padding: 0}}><FaTrash /></Button>
        </Col>
    </Row>
}
